import invariant from 'invariant';
import cloneDeep from 'lodash.clonedeep';

import { Group as ApiGroup } from 'api/groupAdmin';
// eslint-disable-next-line import/no-namespace
import * as groupApi from 'api/groupAdmin';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { Dispatch, GetState } from '../..';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { updateCurrentUser } from '../currentUser';
// eslint-disable-next-line no-restricted-imports
import { setError } from '../error';

// Types

export type Group = ApiGroup & {
  isFetching: boolean;
};
export type State = {
  byId: Record<string, Group>;
};

type FetchGroupRequestAction = {
  type: 'GROUP_DASHBOARD_FETCH_GROUP_REQUEST';
  groupId: string;
};
type FetchGroupSuccessAction = {
  type: 'GROUP_DASHBOARD_FETCH_GROUP_SUCCESS';
  group: ApiGroup;
};
type DeleteGroupAction = {
  type: 'GROUP_DASHBOARD_DELETE_GROUP';
  groupId: string;
};
export type Action =
  | FetchGroupRequestAction
  | FetchGroupSuccessAction
  | DeleteGroupAction;

// Reducer

// eslint-disable-next-line import/no-default-export
export default function groupsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
  },
  action: Action
) {
  switch (action.type) {
    case 'GROUP_DASHBOARD_FETCH_GROUP_REQUEST':
      return {
        byId: {
          ...state.byId,
          [action.groupId]: {
            ...state.byId[action.groupId],
            id: action.groupId,
            isFetching: true,
          },
        },
      };

    case 'GROUP_DASHBOARD_FETCH_GROUP_SUCCESS':
      return {
        byId: {
          ...state.byId,
          [action.group.id]: { ...action.group, isFetching: false },
        },
      };

    case 'GROUP_DASHBOARD_DELETE_GROUP': {
      const newState = { ...state };
      delete newState.byId[action.groupId];
      return newState;
    }

    default:
      return state;
  }
}

// Actions

const fetchGroupRequest = (groupId: string): FetchGroupRequestAction => ({
  type: 'GROUP_DASHBOARD_FETCH_GROUP_REQUEST',
  groupId,
});

const fetchGroupSuccess = (group: ApiGroup): FetchGroupSuccessAction => ({
  type: 'GROUP_DASHBOARD_FETCH_GROUP_SUCCESS',
  group,
});

export const fetchGroup =
  (groupId: string, force?: boolean) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const group = state.groupDashboard.groups.byId[groupId];

    if (!group || force) {
      dispatch(fetchGroupRequest(groupId));
      groupApi
        .fetchGroup(groupId)
        .then((fetchedGroup) => {
          dispatch(fetchGroupSuccess(fetchedGroup));
        })
        .catch((error) => {
          dispatch(setError(error));
        });
    }
  };
export const updateGroup = fetchGroupSuccess;
export const deleteGroup =
  (groupId: string) => (dispatch: Dispatch, getState: GetState) => {
    const currentUser = cloneDeep(getState().currentUser);
    currentUser.groups = (currentUser.groups || []).filter(
      (g) => g.id !== groupId
    );
    return groupApi
      .deleteGroup(groupId)
      .then(() => {
        dispatch({
          type: 'GROUP_DASHBOARD_DELETE_GROUP',
          groupId,
        });
        dispatch(updateCurrentUser(currentUser));
      })
      .catch((error) => {
        dispatch(setError(error));
      });
  };
export const addAdmin =
  (groupId: string, email: string, isOwner: boolean) =>
  (dispatch: Dispatch, getState: GetState) => {
    const apiAddAdmin = isOwner ? groupApi.addOwner : groupApi.addAdmin;
    return apiAddAdmin(groupId, email).then(({ user, invite }) => {
      const group = getState().groupDashboard.groups.byId[groupId];
      invariant(group, 'Invalid group id');

      if (user) {
        if (!group.admins.find((a) => a.id === user.id)) {
          dispatch(updateGroup({ ...group, admins: [...group.admins, user] }));
        } else {
          dispatch(
            updateGroup({
              ...group,
              admins: [user, ...group.admins.filter((a) => a.id !== user.id)],
            })
          );
        }
      } else if (invite) {
        if (!group.invites.find((i) => i.id === invite.id)) {
          dispatch(
            updateGroup({ ...group, invites: [...group.invites, invite] })
          );
        }
      }

      return {
        user,
        invite,
      };
    });
  };
export const makeOwner =
  (groupId: string, userId: string) =>
  (dispatch: Dispatch, getState: GetState) => {
    const group = getState().groupDashboard.groups.byId[groupId];
    const admin = group.admins.find((a) => a.id === userId);
    invariant(admin, 'User is not an admin');
    return groupApi.addOwner(groupId, admin.email).then(({ user }) => {
      invariant(user, 'Missing user');
      dispatch(
        updateGroup({
          ...group,
          admins: [user, ...group.admins.filter((a) => a.id !== user.id)],
        })
      );
    });
  };
export const removeAdmin =
  (groupId: string, userId: string) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const group = state.groupDashboard.groups.byId[groupId];
    const admin = group.admins.find((a) => a.id === userId);
    invariant(admin, 'User is not an admin');
    return groupApi.removeAdmin(groupId, admin.id).then(() => {
      const currentUser = cloneDeep(state.currentUser);
      currentUser.groups = (currentUser.groups || []).filter(
        (g) => g.id !== groupId
      );
      dispatch(
        updateGroup({
          ...group,
          admins: group.admins.filter((a) => a.id !== admin.id),
        })
      );

      if (currentUser.id === admin.id) {
        dispatch(updateCurrentUser(currentUser));
      }
    });
  };
export const approveAdminRequest =
  (groupId: string, requestId: string) =>
  (dispatch: Dispatch, getState: GetState) => {
    const group = getState().groupDashboard.groups.byId[groupId];
    const adminRequest = group.adminRequests.find((r) => r.id === requestId);
    invariant(adminRequest, 'No admin request found');
    return groupApi.approveAdminRequest(groupId, requestId).then((admin) => {
      dispatch(
        updateGroup({
          ...group,
          adminRequests: group.adminRequests.filter((r) => r.id !== requestId),
          admins: [admin, ...group.admins],
        })
      );
    });
  };
export const rejectAdminRequest =
  (groupId: string, requestId: string) =>
  (dispatch: Dispatch, getState: GetState) => {
    const group = getState().groupDashboard.groups.byId[groupId];
    const adminRequest = group.adminRequests.find((r) => r.id === requestId);
    invariant(adminRequest, 'No admin request found');
    return groupApi.rejectAdminRequest(groupId, requestId).then(() => {
      dispatch(
        updateGroup({
          ...group,
          adminRequests: group.adminRequests.filter((r) => r.id !== requestId),
        })
      );
    });
  };
